// composables/useConfirm.js
import { ref } from 'vue';

// Singleton confirm state shared across app
const showConfirm = ref(false);
const confirmMessage = ref('');
const confirmTitle = ref('تایید');
const confirmConfirmText = ref('بله');
const confirmCancelText = ref('انصراف');
let resolvePromise = null;

// --- Info modal (non-destructive) ---
// Separate from confirm so delete dialogs can keep their danger + trash styling.
const showInfo = ref(false);
const infoMessage = ref('');
const infoTitle = ref('پیام');
const infoConfirmText = ref('متوجه شدم');
let resolveInfoPromise = null;

export function useConfirm() {
  const confirm = (opts) => {
    // opts can be a string message or an object { title, message, confirmText, cancelText }
    if (typeof opts === 'string') {
      confirmMessage.value = opts;
    } else if (typeof opts === 'object') {
      confirmTitle.value = opts.title || confirmTitle.value;
      confirmMessage.value = opts.message || '';
      confirmConfirmText.value = opts.confirmText || confirmConfirmText.value;
      confirmCancelText.value = opts.cancelText || confirmCancelText.value;
    }
    showConfirm.value = true;

    return new Promise((resolve) => {
      resolvePromise = resolve;
    });
  };

  const onConfirm = (result) => {
    showConfirm.value = false;
    if (resolvePromise) {
      resolvePromise(result);
      resolvePromise = null;
    }
  };

  return {
    showConfirm,
    confirmMessage,
    confirmTitle,
    confirmConfirmText,
    confirmCancelText,
    confirm,
    onConfirm
  };
}

export function useInfoModal() {
  const info = (opts) => {
    // opts can be a string message or an object { title, message, confirmText }
    if (typeof opts === 'string') {
      infoMessage.value = opts;
    } else if (typeof opts === 'object') {
      infoTitle.value = opts.title || infoTitle.value;
      infoMessage.value = opts.message || '';
      infoConfirmText.value = opts.confirmText || infoConfirmText.value;
    }

    showInfo.value = true;
    return new Promise((resolve) => {
      resolveInfoPromise = resolve;
    });
  };

  const onInfoConfirm = (result) => {
    showInfo.value = false;
    if (resolveInfoPromise) {
      resolveInfoPromise(result);
      resolveInfoPromise = null;
    }
  };

  return {
    showInfo,
    infoMessage,
    infoTitle,
    infoConfirmText,
    info,
    onInfoConfirm
  };
}